import { COLUMN_ENROLMENTS_COUNT, COLUMN_NAME, COLUMN_SITE } from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";

const CategoryColumns : TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "site",
        columnId: COLUMN_SITE,
    },
    {
        heading: "Enrolments",
        accessor: "enrolments",
        isNumeric: true,
        id: 2,
        active: true,
        translationKey: "enrolments",
        columnId: COLUMN_ENROLMENTS_COUNT,
    },
];

export default CategoryColumns
